"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createOnChangeWithTransform = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _identity2 = _interopRequireDefault(require("lodash/identity"));

var _reactDisplayName = _interopRequireDefault(require("react-display-name"));

var createOnChangeWithTransform = function createOnChangeWithTransform(dispatchChange, onChange) {
  var onChangeTransform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;
  var parser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _identity2.default;
  var onValidationSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _identity2.default;
  var onValidationFail = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _identity2.default;
  return function (e) {
    var result = dispatchChange(parser(onChangeTransform(e))).then(onValidationSuccess, onValidationFail);
    onChange && onChange(e);
    return result;
  };
};
/**
 * Higher order component that wraps a given input to be compatible with redux-inputs
 *
 * The wrapped component will be given the following props:
 * - _id - An identifier unique to the input consisting of mount point and input id
 * - value - The current displayed value
 * - error - True if current value is invalid
 * - dispatchChange - callback for updating the value
 * - errorText - String to display to the user of current error
 */


exports.createOnChangeWithTransform = createOnChangeWithTransform;

var ReduxInputsWrapper = function ReduxInputsWrapper(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    onChangeTransform: _identity2.default
  };

  var Wrapper = function Wrapper(_ref) {
    var id = _ref.id,
        _id = _ref._id,
        value = _ref.value,
        parser = _ref.parser,
        formatter = _ref.formatter,
        dispatchChange = _ref.dispatchChange,
        onChange = _ref.onChange,
        onValidationSuccess = _ref.onValidationSuccess,
        onValidationFail = _ref.onValidationFail,
        otherProps = (0, _objectWithoutProperties2.default)(_ref, ["id", "_id", "value", "parser", "formatter", "dispatchChange", "onChange", "onValidationSuccess", "onValidationFail"]);
    var onChangeTransform = options.onChangeTransform;
    return _react.default.createElement(WrappedComponent, (0, _extends2.default)({
      id: id || _id,
      value: formatter ? formatter(value) : value // onChange function to take an event facade, dispatch a change event
      ,
      onChange: createOnChangeWithTransform(dispatchChange, onChange, onChangeTransform, parser, onValidationSuccess, onValidationFail)
    }, otherProps));
  };

  Wrapper.displayName = "ReduxInputsWrapper(".concat((0, _reactDisplayName.default)(WrappedComponent), ")");
  Wrapper.propTypes = {
    /**
     * Generated id from getInputProps (mountPoint:key)
     */
    _id: _propTypes.default.string.isRequired,

    /**
     * Optional override id if you don't want to use default _id from inputConfig key
     */
    id: _propTypes.default.string,

    /**
     * The logical value of the input from the redux store
     */
    value: _propTypes.default.any,

    /**
     * Function to create a value from a change event into a value to store
     */
    parser: _propTypes.default.func,

    /**
     * Function to create a DOM-appropriate string from a value
     */
    formatter: _propTypes.default.func,

    /**
     * Private function from getInputProps, returns a promise
     */
    dispatchChange: _propTypes.default.func.isRequired,

    /**
     * Callback for React's native onChange
     */
    onChange: _propTypes.default.func,

    /**
     * Callback after successful validation and update
     */
    onValidationSuccess: _propTypes.default.func,

    /**
     * Callback after failed validation
     */
    onValidationFail: _propTypes.default.func
  };
  return Wrapper;
};

var _default = ReduxInputsWrapper;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/components/ReduxInputsWrapper.js
// module id = 797
// module chunks = 0